import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl } from "../../ApiSetUp/AuthApi";


//--------------------- Po Apis ------------------------------
export const addDocument = createAsyncThunk(
    "addDocument",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.addDocument, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const updateDocument = createAsyncThunk(
    "updateDocument",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.updateDocument, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getDocuments = createAsyncThunk(
    "getDocuments",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getDocuments, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getDocumentsByType = createAsyncThunk(
    "getDocumentsByType",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getDocumentsByType, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getTotalProduction = createAsyncThunk(
    "getTotalProduction",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getTotalProduction, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getDocumentById = createAsyncThunk(
    "getDocumentById",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.getDocumentById + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const getPoDocumentsByAdvanceLicense = createAsyncThunk(
    "getPoDocumentsByAdvanceLicense",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.getPoDocumentsByAdvanceLicense, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const deleteDocument = createAsyncThunk(
    "deleteDocument",
    async (body) => {
        return ApiGetNoAuth(BaseUrl, api.deleteDocument + body, {})
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);
export const downloadSheet = createAsyncThunk(
    "downloadSheet",
    async (body) => {
        return ApiPostNoAuth(BaseUrl, api.downloadSheet, body)
            .then((res) => {
                return res?.data;
            })
            .catch((err) => err);
    }
);